import axios from "axios";

interface SubjectSelectorPriceInformationUpdate {
	success: boolean
	newSubjectSelectorPriceInformation: string
}

// Placeholder tokens emitted by the C# control in the store url; replaced with the toggled subject + its state.
const SUBJECT_ID_PLACEHOLDER = "PLH_subjectId";
const SUBJECT_SELECTED_PLACEHOLDER = "PLH_subjectSelected";

/**
 * Owns the subject-selection checkbox behaviour. When a checkbox is toggled it persists that subject's
 * state to the session (store url), then fetches the freshly rendered markup (update url) and swaps it in
 * — the same ProgressIndicator + replaceWith mechanism as ProductSelector. The price is recomputed and
 * rendered server-side from the session selection, so it arrives in the re-rendered markup.
 */
export class SubjectSelectorPriceInformation extends ProgressIndicator {
	private readonly subjectSelectorPriceInformation: JQuery;

	constructor(containerId: DOMElementIdentifier, _constructionParameters: ConstructionParameters) {
		super(jQuery("#" + containerId)[0]);

		this.subjectSelectorPriceInformation = jQuery("#" + containerId);
		this.subjectSelectorPriceInformation
			.find(".mia-subjectSelectionCheckbox")
			.on("change", (event) => void this.onToggle(event));
	}

	private async onToggle(event: JQuery.TriggeredEvent): Promise<void> {
		this.showProgressIndicator(true, "", false);

		const checkbox = jQuery(event.currentTarget);
		const subjectId = String(checkbox.data("subject-id"));
		const checked = checkbox.is(":checked");

		const storeUrl = String(this.subjectSelectorPriceInformation.data("store-in-session-url"))
			.replace(SUBJECT_ID_PLACEHOLDER, subjectId)
			.replace(SUBJECT_SELECTED_PLACEHOLDER, String(checked));

		try {
			const { data } = await axios.get<{ success: boolean }>(storeUrl);
			await this.onStored(data);
		}
		finally {
			this.hideProgressIndicator();
		}
	}

	private async onStored(data: { success: boolean }): Promise<void> {
		if (!data.success) {
			return;
		}

		const url = this.subjectSelectorPriceInformation.data("update-url");
		const { data: updateData } = await axios.get<SubjectSelectorPriceInformationUpdate>(url);
		this.onUpdateSucceeded(updateData);
	}

	private onUpdateSucceeded(data: SubjectSelectorPriceInformationUpdate) {
		if (data.success) {
			this.subjectSelectorPriceInformation.replaceWith(data.newSubjectSelectorPriceInformation);
		}
	}
}
